__turbopack_context__.v({
  "fadeIn": "av2rHa_fadeIn",
  "placeholder": "av2rHa_placeholder",
  "searchBarWrapper": "av2rHa_searchBarWrapper",
  "stickyMobileSearchBar": "av2rHa_stickyMobileSearchBar",
});
